//Swiper
import Swiper from 'swiper';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';

class NfxSwiper {
  constructor() {
    this.sliderTabs = Array.from(document.querySelectorAll('.js-swiper-tab'));
    this.slider = null;
  }

  init() {
    if (this.sliderTabs.length > 0) {
      this.initSlider();
      this.onSlideChange();
      this.addTabEventListener(this.sliderTabs);
    }
  }

  initSlider() {
    let initSliderItem = 0;
    const activeTab = this.sliderTabs.filter((tab) => tab.classList.contains('is-active'));

    if (activeTab.length > 0) {
      initSliderItem = parseInt(activeTab[0].dataset.target);
    }

    this.slider = new Swiper('.js-slider', {
      modules: [Navigation, Pagination, Autoplay],
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: false,
      autoplay: true,
      allowTouchMove: true,
      initialSlide: initSliderItem,
    });
  }

  onSlideChange() {
    this.slider.on('slideChange', () => {
      this.switchActiveState(this.sliderTabs, this.slider.activeIndex);
      this.hadleTabbableContent(this.slider.slides)
    });

  }

  switchActiveState(nodeList, index) {
    nodeList.forEach((node) => {
      if (parseInt(node.dataset.target) === index) {
        node.classList.add('is-active');
        node.setAttribute('aria-selected','true');
      } else {
        node.classList.remove('is-active');
        node.setAttribute('aria-selected','false');
      }
    });
    
  }

  addTabEventListener(nodelist) {
    nodelist.forEach((node) => {
      node.addEventListener('click', (e) => {
        const index = parseInt(e.currentTarget.dataset.target);
        this.slider.slideTo(index, 400, true);
        this.switchActiveState(this.sliderTabs, index);
        this.setFocusInsideSlide();
      });

      node.addEventListener('keydown', (e) => {
          if (e.code === 'Space' || e.code === 'Enter') {
            e.preventDefault();
            node.click();
          }
        });
    });

  }

  setFocusInsideSlide() {
    const activeSlide = this.slider.slides[this.slider.activeIndex];
    console.log(this.slider.slides)
    activeSlide.setAttribute('tabindex', '-1');
    activeSlide.setAttribute('role', 'group');
    activeSlide.setAttribute('aria-roledescription', 'slide');

    // Set focus to the slide
    activeSlide.focus();
  }

  hadleTabbableContent(slides) {
    const activeSlide = slides[this.slider.activeIndex];
    slides.forEach(slide => {
        const tabbableContent = slide.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
        if (activeSlide == slide) {
            tabbableContent.forEach(content => {
                content.setAttribute('tabindex', '0');
            })
        } else {
            tabbableContent.forEach(content => {
                content.setAttribute('tabindex', '-1');
            })
        }
    })

  }
}

export default new NfxSwiper();
